/**
 * Created by vladislav on 19/12/2022
 */

cc.MoveInCircle = function (duration, center, position) {
    let angle = Math.atan2(
        position.y - center.y,
        position.x - center.x
    );

    if (angle <= 0) {
        angle += 2 * Math.PI;
    }
    angle += 2 * Math.PI;

    cc.MoveInArc.prototype.constructor.call(this, duration, center, angle);
};

cc.MoveInCircle.prototype = Object.assign(Object.create(cc.MoveInArc.prototype), {
    constructor: cc.MoveInCircle
});